export default {
  create: {
    title: 'Add',
    subtitle: 'Games',
  },
  edit: {
    title: 'Edit',
    subtitle: 'Game',
    button: {
      add: 'New game',
    },
  },
  list: {
    title: 'Fences',
    subtitle: 'List',
    add: 'New game',
  },
  card: {
    title: 'Fences',
    actions: 'Actions',
  },
  table: {
    title: 'Active games',
    searchPlaceholder: 'Search...',
  },
  form: {
    name: {
      label: 'Name:',
      placeholder: 'E.g.: Fences Level 1',
      invalid: 'Name is required',
    },
    showAnswer: {
      label: 'Show answer',
    },
    colored: {
      label: 'Colored',
    },
    columns: {
      label: 'Columns:',
    },
    rows: {
      label: 'Rows:',
    },
    extraClues: {
      label: 'Extra clues:',
      tooltipLine1:
        'The algorithm sets the minimum number of clues for a unique solution.',
      tooltipLine2: 'Add extra clues to make the game easier for the player.',
    },
    invalidDimension:
      'Invalid combination: Row and Column cannot both be even. At least one must be odd.',
  },
  button: {
    generate: 'Generate game',
  },
  sidebar: {
    exportHint: 'You need to save before exporting.',
    defaultFileName: 'fences',
  },
  status: {
    summary: '{total} clues, {base} fixed and {extra} extra',
    legendTitle: 'Color legend',
    fixedClues: '{count} fixed clues',
    extraClues: '{count} extra clues',
    answerVisible: 'Answer visible',
    answerHidden: 'Answer hidden',
  },
  alert: {
    generated: 'Puzzle generated in {duration}s!',
    generateFailed: 'Error generating the puzzle.',
    workerCritical: 'Critical internal error during generation.',
    gameSaved: 'Game saved successfully!',
    workerErrors: {
      pathGenerationFailed: 'Error generating the path.',
    },
  },
};
